import React from 'react';
import { ShareLinkContent } from '../share-link-content/component';

export const ShareJoinCanvasLinkContent = (props) => {
  const { link, headingText, variant } = props;
  return <ShareLinkContent link={link} headingText={headingText} variant={variant} />;
};
